export const isSellingLive: boolean =
  process.env.NEXT_PUBLIC_SELLING_LIVE === 'true'
